import { LANGUAGES } from 'src/_shared/constants';
import { DEFAULT_LANGUAGE } from 'src/_shared/config';
export function getUserLanguage(cookieValue) {
    if (cookieValue && Object.keys(LANGUAGES).includes(cookieValue)) {
        return LANGUAGES[cookieValue];
    }
    return DEFAULT_LANGUAGE;
}
